<template>
   <div class="empty">
      <van-empty  image="https://account.kmmds.top/datainfo_pic/error.png" description="暂无就诊卡信息" />
     <div class="emptyBtn">
        <van-button
        color="#5B8DF6"
        plain
        size="large"
        class="emptyBtn_text"
        round
        @click="btnClick"
        >立即绑卡</van-button
      >
     </div>
     </div>
</template>

<script>
export default {
    methods:{
      btnClick(){
        this.$emit("btnClick")
      }
    }
}
</script>

<style lang="scss">
.empty{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    .emptyBtn{
      width: 80%;
      margin: 0px auto;
      margin-top: 25vh;

      .emptyBtn_text{
        letter-spacing:5px;
      }
    }
  }
</style>